import { fromJS } from 'immutable'
import { ActionType } from './i18n.actions'
import * as i18nTypes from './i18n.types'

export const initialState = fromJS({
  avaliableLanguages: {
    isLoading: false,
    data: null,
  },
  defaultTranslations: {
    isLoading: false,
    data: null,
  },
  contentEditable: {
    isEnabled: false,
  },
  translationsList: {
    isLoading: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 20,
    },
    total: 0,
    results: 0,
  },
})

export function i18nReducer(state = initialState, action: ActionType) {
  switch (action.type) {
    case i18nTypes.FETCH_AVALIABLE_LANGUAGES_REQUEST: {
      return state.setIn(['avaliableLanguages', 'isLoading'], true)
    }
    case i18nTypes.FETCH_AVALIABLE_LANGUAGES_SUCCESS: {
      return state
        .setIn(['avaliableLanguages', 'isLoading'], false)
        .setIn(['avaliableLanguages', 'data'], fromJS(action.payload))
    }
    case i18nTypes.FETCH_AVALIABLE_LANGUAGES_FAILURE: {
      return state.setIn(['avaliableLanguages', 'isLoading'], false)
    }

    case i18nTypes.FETCH_DEFAULT_TRANSLATIONS_REQUEST: {
      return state.setIn(['defaultTranslations', 'isLoading'], true)
    }
    case i18nTypes.FETCH_DEFAULT_TRANSLATIONS_SUCCESS: {
      return state
        .setIn(['defaultTranslations', 'isLoading'], false)
        .setIn(['defaultTranslations', 'data'], fromJS(action.payload))
    }
    case i18nTypes.FETCH_DEFAULT_TRANSLATIONS_FAILURE: {
      return state.setIn(['defaultTranslations', 'isLoading'], false)
    }

    case i18nTypes.IS_CONTENT_EDITABLE_ENABLED: {
      return state.setIn(['contentEditable', 'isEnabled'], action.payload)
    }

    case i18nTypes.FETCH_TRANSLATIONS_LIST_REQUEST: {
      return state.setIn(['translationsList', 'isLoading'], true)
    }

    case i18nTypes.FETCH_TRANSLATIONS_LIST_SUCCESS: {
      return state
        .setIn(['translationsList', 'isLoading'], false)
        .setIn(['translationsList', 'data'], fromJS(action.payload))
        .setIn(['translationsList', 'total'], fromJS(action.total))
        .setIn(['translationsList', 'results'], fromJS(action.results))
    }

    case i18nTypes.FETCH_TRANSLATIONS_LIST_FAILURE: {
      return state.setIn(['translationsList', 'isLoading'], false)
    }

    case i18nTypes.UPDATE_FIELD: {
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    }

    default:
      return state
  }
}
